import React, { useState, useEffect, useCallback } from 'react';
import { Card, NoticeBar } from 'antd-mobile';

import { UrlSearch } from "../../../utils/utils";

import * as Api from "../../../api/usms";
import { TimeFormatType, TextCategory, AuditingStatus, UsmsType, UsmsStatus, UsmsStatusStyle, Purpose } from '../utils/const';
import { Loading, Descriptions } from '../components';
import CompanyInfo from '../components/CompanyInfo';
import Audit from './Audit';

import moment from 'moment';
import '../index.css';

function TemplateDetail(props) {

  const [templateId, setTemplateId] = useState("");
  const [info, setInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [alertInfo, setAlertInfo] = useState(null);

  useEffect(() => {
    initData();
  }, [])

  const initData = () => {
    const id = UrlSearch("id");
    setTemplateId(id);
    if (id) {
      getInfo(id);
    }
  }

  const getInfo = (templateId) => {
    const data = {
      TemplateCategory: TextCategory,
      TemplateId: templateId,
    }
    setLoading(true);
    Api.DescribeUSMSTemplateWithRisk(data).then(res => {
      if (res && res.length) {
        const info = res[0] || {};
        setInfo(info);
        if (info.Template) {
          Api.PreviewUSMSTemplateInfo({
            Content: info.Template,
          }).then(alert => {
            if (alert && alert.Data) {
              setAlertInfo(alert.Data);
            }
          }).catch(e => console.log(e));
        }
      }
      setLoading(false);
    }).catch(e => {
      setLoading(false);
      setErrorMessage(e.message || "获取数据失败")
    });
  }

  const AlertPanel = useCallback(
    ({ showInfo }) => {
      return (
        <>
          {showInfo ? (
            <div style={{ marginBottom: '8px' }}>
              计费规则：
              <ul>
                <li>
                - 纯英文，统一160字/条，超出160字按 154字/条 计算
                </li>
                <li>
                - 非纯英文，统一70字/条，超出70字按 67字/条 计算
                </li>
              </ul>
            </div>
          ) : null}
          {alertInfo ? (
            <NoticeBar marqueeProps={{ loop: true }}>
              <div>
                {/* 该模板是 <strong>{alertInfo.IsLongSms ? '长短信' : '非长短信'}</strong>， */}
                {/* <strong>{alertInfo.IsPureEnglish ? '纯英文' : '非纯英文'}</strong> 短信模板 <br /> */}
                包含变量个数：{alertInfo.VariableCount} 个；
                当前包含字符数：{alertInfo.MinContentLen}；
                {alertInfo.VariableCount <= 0 ? '' : '最小'}计费条数：{alertInfo.MinCostCount} 条
              </div>
            </NoticeBar>
          ) : null}
        </>
      );
    },
    [alertInfo]
  );

  const AlertModalPanel = useCallback(() => {
    if (!alertInfo) {
      return '';
    }
    
    return (
      <ul>
        <li>包含变量个数：{alertInfo.VariableCount} 个</li>
        <li>当前包含字符数：{alertInfo.MinContentLen}</li>
        <li>{alertInfo.VariableCount <= 0 ? '' : '最小'}计费条数：{alertInfo.MinCostCount} 条</li>
      </ul>
    )
  }, [alertInfo]);

  const infoOptions = (info) => [
    { label: '模版ID', value: info.TemplateId },
    { label: '短信类型', value: UsmsType[info.TemplateCategory] },
    { label: '模板类型', value: Purpose[info.Purpose] },
    { label: '模板名称', value: info.TemplateName },
    // { label: '国家简码', value: info.BrevityCode },
    { label: '当前状态', value: <span className={UsmsStatusStyle[info.Status]}>{UsmsStatus[info.Status]}</span> },
    { label: '申请时间', value: moment(info.CreateTime * 1000).format(TimeFormatType.time_xg) },
    { label: '备注', value: info.Remark },
    { label: '模版内容', value: info.Template },
  ]
  return (
    <div className="container">
      <h3 className='mb-10'>短信模版：{templateId}</h3>
      <Loading loading={loading} error={errorMessage}>
        {alertInfo ? <AlertPanel showInfo /> : null}
        <div>
          <Card>
            <Card.Body>
              <CompanyInfo CompanyId={info.CompanyId} />
            </Card.Body>
          </Card>
          <Card style={{ marginTop: '10px' }}>
            <Card.Header title="模版信息" />
            <Card.Body>
              <Descriptions options={infoOptions(info)} />
            </Card.Body>
          </Card>
          {AuditingStatus.includes(info.Status) ?
            <div style={{ marginTop: '20px' }}>
              <h3 style={{ marginBottom: '10px' }}>模版审核：</h3>
              <Audit info={info} AlertModalPanel={AlertModalPanel} fetchBack={() => getInfo(templateId)} />
            </div> : null}
        </div>
      </Loading>
    </div>
  )
}

export default TemplateDetail